export const SN_PRODUCT = 'product'
export const PRODUCT_LIST_UPDATED = SN_PRODUCT + '/LIST_UPDATED'
export const PRODUCT_ADD_TO_CACHED = SN_PRODUCT + '/ADD_TO_CACHED'
export const PRODUCT_ADD_TO_CACHED_MULTIPLE = SN_PRODUCT + '/ADD_TO_CACHED_MULTIPLE'
export const PRODUCT_CURRENT_UPDATED = SN_PRODUCT + '/CURRENT_UPDATED'
export const PRODUCT_CURRENT_LIST_UPDATED = SN_PRODUCT + '/CURRENT_LIST_UPDATED'
export const PRODUCT_CURRENT_TOTAL_PRE_ORDERS_UPDATED = SN_PRODUCT + '/CURRENT_TOTAL_PRE_ORDERS_UPDATED'
export const PRODUCT_CACHED_UPDATED = SN_PRODUCT + '/CACHED_UPDATED'
export const PRODUCT_CATALOG_UPDATED = SN_PRODUCT + '/CATALOG_UPDATED'
export const PRODUCT_CURRENT_CTLGPRDCT_UPDATED = SN_PRODUCT + '/CURRENT_CTLGPRDCT_UPDATED'
export const PRODUCT_STR_CAT_UPDATED = SN_PRODUCT + '/STR_CAT_UPDATED'